import React from "react";
import ContainerTestimonial from "./ContainerTestimonial/ContainerTestimonial";
import Shared02Headings from "../../guestsharedcomponents/Shared02Headings/Shared02Headings";

const G08Testimonial = () => {
  return (
    <section className="t-ptb-10 t-overflow-x-hidden">
      <div className="t-container">
        <Shared02Headings
          options={{
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: {
              margin: "0 auto",
            },
            container_desktop_styles: {},
            obj_heading: {
              main_text:
                "Real Dancers. <span class='t-enlace'>Real Results.</span>",
              main_tag_version: "h2",
              main_text_css: "t-h-1",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "900",
                "margin-bottom": "0.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },
            obj_support_heading: {
              main_text:
                "Join dancers around the world who are building confidence, connection, and <span class='t-enlace'>real progress, together</span>",
              main_tag_version: "h3",
              main_text_css: "t-h-4",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "700",
                "margin-bottom": "5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },

            obj_divider: {
              divider_mobile_styles: {
                width: "100%",
                background:
                  "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                margin: "0 auto 6rem auto",
              },
              divider_desktop_styles: {},
            },
            obj_paragraph: false,
            obj_buttons: false,
            heading_version: "heading_01",
          }}
        />
      </div>
      <ContainerTestimonial />
    </section>
  );
};

export default G08Testimonial;
